import { AlertTriangle, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { reais } from "../lib/caixa";
import { destinoDaMesa, desdeQuando, quandoDoPedido, resumoEmAberto, rotuloModulo, rotuloStatus, telaDoPedido, temEmAberto } from "../lib/emAberto";

function Linha({ partes, botao, onIr, e2e }) {
  return (
    <li className="flex items-center gap-2 text-xs text-red-700/90 dark:text-red-300" data-e2e={e2e}>
      <span className="min-w-0 flex-1 truncate">{partes.filter(Boolean).join(" · ")}</span>
      <button
        type="button"
        onClick={onIr}
        className="shrink-0 inline-flex items-center gap-1 rounded-full border border-red-300 dark:border-red-700 px-2.5 py-0.5 font-semibold text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/40 active:scale-95 transition"
      >
        {botao}<ArrowRight className="w-3 h-3" />
      </button>
    </li>
  );
}

/**
 * Tudo o que está em aberto na loja — pedidos de qualquer canal e mesas com
 * produto ou pagamento — trava o fechamento do caixa (decisão do dono,
 * 22/10/2026). O servidor recusa com a mesma lista (409) mesmo que a tela seja
 * contornada. O botão do pedido leva à tela do módulo dele ("Ir para Delivery",
 * "Ir para Balcão"…, 25/10/2026); o da mesa leva só à tela de Mesas. Os dois fecham
 * esta janela (`aoIr`).
 */
export default function AvisoEmAberto({ emAberto, aoIr }) {
  const navigate = useNavigate();
  if (!temEmAberto(emAberto)) return null;
  const ir = (destino) => { aoIr?.(); navigate(destino); };
  const pedidos = emAberto.pedidos || [];
  const mesas = emAberto.mesas || [];
  return (
    <div className="mb-4 rounded-lg border border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-950/30 p-3" data-e2e="aviso-em-aberto">
      <p className="text-sm font-semibold text-red-700 dark:text-red-400 flex items-center gap-1.5">
        <AlertTriangle className="w-4 h-4 shrink-0" />Resolva o que está em aberto antes de fechar o caixa
      </p>
      <p className="mt-0.5 text-xs text-red-700/80 dark:text-red-300/80">
        {resumoEmAberto(emAberto)} na loja inteira. Conclua ou cancele cada pedido e feche ou cancele cada mesa; depois abra o Fechar caixa de novo.
      </p>
      <ul className="mt-2 space-y-1">
        {pedidos.map((p) => (
          <Linha
            key={p.pedido_id}
            e2e="em-aberto-pedido"
            partes={[
              p.codigo ? `#${String(p.codigo).replace(/^#/, "")}` : "Pedido",
              rotuloModulo(p.modulo),
              rotuloStatus(p.status) + (p.reaberto_por ? ` (reaberto por ${p.reaberto_por})` : ""),
              reais(p.total),
              p.cliente,
              quandoDoPedido(p),
            ]}
            botao={`Ir para ${telaDoPedido(p).nome}`}
            onIr={() => ir(telaDoPedido(p).rota)}
          />
        ))}
        {mesas.map((m) => (
          <Linha
            key={m.mesa_id}
            e2e="em-aberto-mesa"
            partes={[
              m.nome,
              m.status === "fechamento" ? "aguardando pagamento" : "aberta",
              reais(m.total),
              m.pago > 0 ? `pago ${reais(m.pago)}` : "",
              m.pedidos > 0 ? `${m.pedidos} pedido${m.pedidos > 1 ? "s" : ""} na cozinha` : "",
              desdeQuando(m.aberta_em),
            ]}
            botao="Ir para Mesas"
            onIr={() => ir(destinoDaMesa(m))}
          />
        ))}
      </ul>
    </div>
  );
}
